angular.module('rjmNg.directives').directive "fullscreen", [
  "$window"
  ($window) ->
    (scope, element, attrs) ->
      fullscreenOn = false
      $(element).click ->
        doc = $window.document
        el = $window.document.documentElement
        fullscreenOn = not fullscreenOn
        if fullscreenOn
          rfs = el.requestFullScreen or el.webkitRequestFullScreen or el.mozRequestFullScreen
          rfs.call el
        else
          rfs = doc.cancelFullscreen or doc.webkitCancelFullScreen or doc.mozCancelFullScreen
          rfs.call doc

        $("body").toggleClass "fullScreen"
  ]
